export const PackagesIDs = {
    PREMIUM: 'PREMIUM',
    WELCOME: 'WELCOME',
    STANDARD: 'STANDARD',
    UNLIMITED: 'UNLIMITED',
    USER: 'USER',
    ALL: 'ALL'
};

export const premiumPackages = [PackagesIDs.PREMIUM, PackagesIDs.UNLIMITED];

export const BillingStatus = Object.freeze({
    active: 'active',
    notActive: 'notactive',
    expired: 'expired'
});

export const StatusRingColor = Object.freeze({
    active: 'bg-primary-500',
    notactive: 'bg-red-600',
    expired: 'bg-neutral-500'
});

export function calcExpirationDate(datePurchase) {
    const date = new Date(datePurchase);
    return date.setFullYear(date.getFullYear() + 1);
}

export function msToMonths(ms) {
    // Costanti
    var msADay = 1000 * 60 * 60 * 24;
    var daysAYear = 365.25;
    var daysAMonth = daysAYear / 12;

    // Converti millisecondi in giorni
    var days = ms / msADay;

    // Calcola il numero approssimativo di mesi
    var months = days / daysAMonth;

    return months;
}

function getValidItems(items) {
    const currentDate = new Date(); // Data attuale

    // Filtra gli elementi con startDate valida e che non sono scaduti
    const validItems = items.filter((item) => {
        const startDate = new Date(item.datePurchase);
        const endDate = new Date(item.dateExpire || calcExpirationDate(item.datePurchase));

        return startDate.getTime() <= currentDate.getTime() && endDate.getTime() >= currentDate.getTime();
    });

    return validItems.length > 0 ? validItems : [];
}

export function findValidItem(items, packs) {
    if (!items || !packs || !packs.length) return null;

    const validItems = getValidItems(items);

    // Trova l'elemento con la priorità più alta tra quelli validi
    if (!validItems || !validItems.length) {
        return null; // Nessun elemento valido
    }

    return validItems.reduce(
        (highestPriorityItem, currentItem) => {
            const pack = packs.find((el) => el.id === currentItem?.packageId);
            return pack?.priority > highestPriorityItem?.priority ? pack : highestPriorityItem;
        },
        { priority: 0 }
    );
}

export function findActivePackage(items, packs) {
    if (!items || !packs || !packs.length) return null;

    const validItems = getValidItems(items);

    if (!validItems || !validItems.length) {
        return null; // Nessun elemento valido
    }

    return validItems.reduce(
        (highestPriorityItem, currentItem) => {
            const pack = packs.find((el) => el.id === currentItem?.packageId);
            const expireDate = new Date(currentItem?.dateExpire);
            return pack?.priority > highestPriorityItem?.priority
                ? Object.assign(currentItem, {
                    priority: pack?.priority,
                    description: pack?.description,
                    expireDate: expireDate?.toLocaleDateString()
                })
                : highestPriorityItem;
        },
        { priority: -1, description: '', expireDate: '' }
    );
}

export function getPurchasesRowsData(purchases, activePack) {
    return purchases
        .map(
            (el) =>
                el.id === activePack?.id || el.packageId === 'USER' // ACTIVE PACK      // TODO: Capire come usare _t.global.package.user()
                    ? { ...el, status: BillingStatus.active }
                    : new Date(el.dateExpire) > new Date() // NOT ACTIVE
                        ? { ...el, status: BillingStatus.notActive }
                        : { ...el, status: BillingStatus.expired } // EXPIRED
        )
        .sort((a, b) => {
            const statusOrder = {
                [BillingStatus.active]: 0,
                [BillingStatus.notActive]: 1,
                [BillingStatus.expired]: 2
            };

            return statusOrder[a.status] - statusOrder[b.status];
        });
}
